/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M13 22V11.2C13 10.0799 13 9.51984 13.218 9.09202C13.4097 8.71569 13.7157 8.40973 14.092 8.21799C14.5198 8 15.0799 8 16.2 8H17M10 14H17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2Z"
				fill="currentColor"
			/>
			<path
				d="M13 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H13ZM13 22V11.2C13 10.0799 13 9.51984 13.218 9.09202C13.4097 8.71569 13.7157 8.40973 14.092 8.21799C14.5198 8 15.0799 8 16.2 8H17M10 14H17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.25305 1.84946C5.42957 1.25 6.96971 1.25 10.05 1.25H13.95C17.0303 1.25 18.5704 1.25 19.7469 1.84946C20.7818 2.37677 21.6232 3.21816 22.1505 4.25305C22.75 5.42957 22.75 6.96971 22.75 10.05V13.95C22.75 17.0303 22.75 18.5704 22.1505 19.7469C21.6232 20.7818 20.7818 21.6232 19.7469 22.1505C18.5704 22.75 17.0303 22.75 13.95 22.75H13.75V14.75H17C17.4142 14.75 17.75 14.4142 17.75 14C17.75 13.5858 17.4142 13.25 17 13.25H13.75V11.2C13.75 10.6276 13.7506 10.2434 13.7748 9.94748C13.7982 9.66035 13.8401 9.52307 13.8862 9.43251C14.0061 9.19731 14.1973 9.00608 14.4325 8.88624C14.5231 8.8401 14.6604 8.79822 14.9475 8.77476C15.2434 8.75058 15.6276 8.75 16.2 8.75H17C17.4142 8.75 17.75 8.41421 17.75 8C17.75 7.58579 17.4142 7.25 17 7.25H16.2L16.1696 7.25H16.1695C15.6354 7.24999 15.1896 7.24998 14.8253 7.27974C14.4454 7.31078 14.0888 7.37789 13.7515 7.54973C13.2341 7.81338 12.8134 8.23408 12.5497 8.75153C12.3779 9.08879 12.3108 9.44545 12.2797 9.82533C12.25 10.1896 12.25 10.6354 12.25 11.1696V11.2V13.25H10C9.58579 13.25 9.25 13.5858 9.25 14C9.25 14.4142 9.58579 14.75 10 14.75H12.25V22.75H10.05C6.96971 22.75 5.42957 22.75 4.25305 22.1505C3.21816 21.6232 2.37677 20.7818 1.84946 19.7469C1.25 18.5704 1.25 17.0303 1.25 13.95V10.05C1.25 6.96971 1.25 5.42957 1.84946 4.25305C2.37677 3.21816 3.21816 2.37677 4.25305 1.84946Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M17 8H16.2C15.0799 8 14.5198 8 14.092 8.21799C13.7157 8.40973 13.4097 8.71569 13.218 9.09202C13 9.51984 13 10.0799 13 11.2V22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V15.5C2 16.8945 2 17.5918 2.13815 18.1672C2.57707 19.9955 4.00453 21.4229 5.83277 21.8618C6.40821 22 7.10547 22 8.5 22V22H9M10 14H17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M13 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H13ZM13 22V11.2C13 10.0799 13 9.51984 13.218 9.09202C13.4097 8.71569 13.7157 8.40973 14.092 8.21799C14.5198 8 15.0799 8 16.2 8H17M10 14H17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M10.05 1.25C6.96971 1.25 5.42957 1.25 4.25305 1.84946C3.21816 2.37677 2.37677 3.21816 1.84946 4.25305C1.25 5.42957 1.25 6.96971 1.25 10.05V13.95C1.25 17.0303 1.25 18.5704 1.84946 19.7469C2.37677 20.7818 3.21816 21.6232 4.25305 22.1505C5.42957 22.75 6.96971 22.75 10.05 22.75H13.95C17.0303 22.75 18.5704 22.75 19.7469 22.1505C20.7818 21.6232 21.6232 20.7818 22.1505 19.7469C22.75 18.5704 22.75 17.0303 22.75 13.95V10.05C22.75 6.96971 22.75 5.42957 22.1505 4.25305C21.6232 3.21816 20.7818 2.37677 19.7469 1.84946C18.5704 1.25 17.0303 1.25 13.95 1.25H10.05Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16.1696 7.25L16.2 7.25H17C17.4142 7.25 17.75 7.58579 17.75 8C17.75 8.41421 17.4142 8.75 17 8.75H16.2C15.6276 8.75 15.2434 8.75058 14.9475 8.77476C14.6604 8.79822 14.5231 8.8401 14.4325 8.88624C14.1973 9.00608 14.0061 9.19731 13.8862 9.43251C13.8401 9.52307 13.7982 9.66036 13.7748 9.94748C13.7506 10.2434 13.75 10.6276 13.75 11.2V13.25H17C17.4142 13.25 17.75 13.5858 17.75 14C17.75 14.4142 17.4142 14.75 17 14.75H13.75V22V22.75H12.25V22V14.75H10C9.58579 14.75 9.25 14.4142 9.25 14C9.25 13.5858 9.58579 13.25 10 13.25H12.25V11.2L12.25 11.1696C12.25 10.6354 12.25 10.1896 12.2797 9.82533C12.3108 9.44545 12.3779 9.08879 12.5497 8.75153C12.8134 8.23408 13.2341 7.81338 13.7515 7.54973C14.0888 7.37789 14.4454 7.31078 14.8253 7.27974C15.1896 7.24998 15.6354 7.24999 16.1696 7.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
